import { CommentPlanFilter, DEFAULT_COMMENT_FILTER } from '@constants'
import produce from 'immer'
import { cloneDeep } from 'lodash-es'
import create from 'zustand'
import { combine } from 'zustand/middleware'
import { validate } from '../middleware'

/**
 * The single comment category currently shown: a plan (stiffeningPlan /
 * positionPlan / loadPlan – a `showInPlans` flag) or the Notiz/plan-less
 * category. Only comments of this category appear, on the currently visible
 * storeys.
 *
 * Kept separate from `modelStore` on purpose: these are not real `ElementTypes`,
 * so adding them to the model element-type enums would ripple into meshing /
 * labels / etc.
 */
interface CommentFilterInitialState {
  selectedPlan: CommentPlanFilter
}

interface CommentFilterStoreType extends CommentFilterInitialState {
  setSelectedPlan: (plan: CommentPlanFilter) => void
  clear: () => void
}

const buildInitialState = (): CommentFilterInitialState => ({
  selectedPlan: DEFAULT_COMMENT_FILTER,
})

const initialState = buildInitialState()

const createStore = () =>
  create<CommentFilterStoreType>(
    validate(
      combine(cloneDeep(initialState), set => ({
        setSelectedPlan: (plan: CommentPlanFilter) =>
          set(
            produce(state => {
              state.selectedPlan = plan
            }),
          ),

        clear: () => set(buildInitialState()),
      })),
    ),
  )

const useCommentFilterStore = createStore()

export { useCommentFilterStore }
